import options from './search.component';
import ThingNameComponent from './thing-name';
import ThingOwnerComponent from './thing-owner';
import ThingStatusComponent from './thing-status';
import ThingStarComponent from './thing-star';
import ThingPictureComponent from './thing-picture';
import ThingTypeComponent from './thing-type';
import ThingBatteryComponent from './thing-battery';
import ThingSignalComponent from './thing-signal';
import ThingRegisteredComponent from './thing-registered';
import ThingUpdatedComponent from './thing-updated';
import ThingLocationComponent from './thing-location';
import ThingLabelsComponent from './thing-labels';
import ThingNotesComponent from './thing-notes';
import ThingFoldersComponent from './thing-folders';

const Component = {
    selector: 'dtThingsSearchAdvanced',
    options
};

export {
    Component,
    ThingNameComponent,
    ThingOwnerComponent,
    ThingStatusComponent,
    ThingStarComponent,
    ThingPictureComponent,
    ThingTypeComponent,
    ThingBatteryComponent,
    ThingSignalComponent,
    ThingRegisteredComponent,
    ThingUpdatedComponent,
    ThingLocationComponent,
    ThingLabelsComponent,
    ThingNotesComponent,
    ThingFoldersComponent,
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/index.js